import { css } from '@emotion/css';

import { AI_COLORS } from '@/components/LyearnAI/consts';

export const aiButtonIconColor = css`
  fill: ${AI_COLORS.royalBlue};
`;

export const aiLoaderStyles = css`
  path:nth-child(2) {
    stroke: ${AI_COLORS.royalBlue};
  }
`;

export const aiToolbarBtn = css`
  color: ${AI_COLORS.lilacPink} !important;
  &:hover {
    background-color: ${AI_COLORS.chalkPink};
  }
`;
